import { Landmark, CheckCircle, XCircle, CreditCard } from "lucide-react";

export function WompiPanel({ wompiStatus, transactions }) {
  const connected = wompiStatus?.connected;

  return (
    <div data-testid="wompi-panel" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <div className="panel-header">
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Landmark size={10} strokeWidth={1.5} style={{ color: connected ? "#34C759" : "#FF3B30" }} />
          <span className="panel-title">WOMPI GATEWAY</span>
        </div>
        <span className="font-mono" style={{
          fontSize: 9,
          color: connected ? "#34C759" : "#FF3B30"
        }}>
          {connected ? "CONECTADO" : "DESCONECTADO"}
        </span>
      </div>

      {/* Merchant Info */}
      {connected && (
        <div style={{
          display: "grid", gridTemplateColumns: "1fr 1fr",
          gap: 1, background: "rgba(255,255,255,0.04)",
          marginBottom: 8, flexShrink: 0
        }}>
          <div style={{ padding: "6px 8px", background: "#09090b" }}>
            <div className="font-mono" style={{ fontSize: 8, color: "#71717a", letterSpacing: "0.1em" }}>MERCHANT</div>
            <div className="font-mono" style={{ fontSize: 11, color: "#d4d4d8" }}>
              {wompiStatus.merchant_name}
            </div>
          </div>
          <div style={{ padding: "6px 8px", background: "#09090b" }}>
            <div className="font-mono" style={{ fontSize: 8, color: "#71717a", letterSpacing: "0.1em" }}>ID</div>
            <div className="font-mono" style={{ fontSize: 11, color: "#d4d4d8" }}>
              {wompiStatus.merchant_id}
            </div>
          </div>
          <div style={{ padding: "6px 8px", background: "#09090b" }}>
            <div className="font-mono" style={{ fontSize: 8, color: "#71717a", letterSpacing: "0.1em" }}>MONEDA</div>
            <div className="font-mono" style={{ fontSize: 11, color: "#34C759" }}>
              {wompiStatus.accepted_currencies?.join(", ") || "COP"}
            </div>
          </div>
          <div style={{ padding: "6px 8px", background: "#09090b" }}>
            <div className="font-mono" style={{ fontSize: 8, color: "#71717a", letterSpacing: "0.1em" }}>ESTADO</div>
            <div className="font-mono" style={{ fontSize: 11, color: wompiStatus.active ? "#34C759" : "#FFCC00" }}>
              {wompiStatus.active ? "ACTIVO" : "SANDBOX"}
            </div>
          </div>
        </div>
      )}

      {/* Recent Transactions */}
      <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div className="font-mono" style={{
          fontSize: 8, color: "#71717a", letterSpacing: "0.15em",
          marginBottom: 4, flexShrink: 0
        }}>
          TRANSACCIONES RECIENTES
        </div>
        <div style={{ flex: 1, overflowY: "auto" }}>
          {(!transactions || transactions.length === 0) ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 60 }}>
              <span className="font-mono" style={{ fontSize: 9, color: "#52525b" }}>
                Sin transacciones aun
              </span>
            </div>
          ) : (
            transactions.slice(0, 10).map((tx, i) => (
              <div key={tx.id || i} data-testid={`wompi-tx-${i}`} style={{
                display: "flex", alignItems: "center", gap: 6,
                padding: "4px 0", borderBottom: "1px solid rgba(255,255,255,0.04)"
              }}>
                <CreditCard size={10} strokeWidth={1.5} style={{
                  color: tx.status === "paid" ? "#34C759" : tx.status === "failed" ? "#FF3B30" : "#FFCC00"
                }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="font-mono" style={{ fontSize: 10, color: "#d4d4d8" }}>
                    {tx.reference}
                  </div>
                  <div className="font-mono" style={{ fontSize: 9, color: "#71717a" }}>
                    {tx.product_name}
                  </div>
                </div>
                <div className="font-mono" style={{ fontSize: 10, color: "#d4d4d8", textAlign: "right" }}>
                  ${tx.amount_cop?.toLocaleString()} COP
                </div>
                {tx.status === "paid" ? (
                  <CheckCircle size={10} style={{ color: "#34C759" }} />
                ) : tx.status === "failed" ? (
                  <XCircle size={10} style={{ color: "#FF3B30" }} />
                ) : (
                  <div className="pulse-dot" style={{ background: "#FFCC00", width: 6, height: 6 }} />
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
